"use strict";
exports.__esModule = true;
var react_1 = require("react");
var useInterval = function (callback, delay) {
    var savedCallback = react_1.useRef();
    var intervalId = react_1.useRef();
    var _a = react_1.useState(true), isRunning = _a[0], setIsRunning = _a[1];
    var clear = react_1.useCallback(function () { return clearInterval(intervalId.current); }, []);
    var run = react_1.useCallback(function () {
        var tick = function () {
            var _a;
            (_a = savedCallback.current) === null || _a === void 0 ? void 0 : _a.call(savedCallback);
        };
        if (delay) {
            intervalId.current = setInterval(tick, delay);
        }
    }, [delay]);
    var stop = react_1.useCallback(function () {
        setIsRunning(false);
    }, [setIsRunning]);
    var start = react_1.useCallback(function () {
        setIsRunning(true);
    }, [setIsRunning]);
    var reset = react_1.useCallback(function () {
        clear();
        if (isRunning) {
            run();
        }
    }, [clear, run, isRunning]);
    // Remember the latest callback
    react_1.useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval
    react_1.useEffect(function () {
        if (intervalId.current) {
            clear();
        }
        if (isRunning) {
            run();
        }
        return clear;
    }, [run, isRunning, clear]);
    return {
        start: start,
        stop: stop,
        reset: reset,
        isRunning: isRunning
    };
};
exports["default"] = useInterval;
//# sourceMappingURL=useInterval.js.map